import { Button, Box } from '@mui/material'
import { makeBookingInDayViewCalendar } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingComponents'
import HoldSlotAndSendLInkToPayButton from 'src/clinic/components/ClinicManageBookingsPage/newBookingCalendar/HoldSlotAndSendLInkToPayButton'
import { allAvailableEventTypes, PAY_IN_FUTURE_ALLOWED_MENTOR_IDS } from 'src/consumer/constants'

export default function BookingDialogActions({
  isEnoughTimeToBook,
  askPayment,
  paymentDetail,
  eventDataForSelectedEventType,
  forMentor,
  tryBookingScreening,
  reasonForNotDoingScreening,
  bookNowHandler,
  paymentLinkToSendViaQRCodeFunction,
  clinicId,
  clinicBrandId,
  mentorProfileData,
  clickedWantedSlotData,
  selectedPatient,
  updateBookingsInCalendar,
  setNewBookingDialogOpen,
  setBookingLoading,
  setSelectedPatient,
  setIsNewPatient,
  setNewPatientInputData,
  chosenChamberRoomId,
  selectedRelatedConsultationForTherapy,
  meetingBookApiSignature,
  relatedToPatient,
  forceHoldingSlot = false,
  hideBookButton = false,
}) {
  let showHoldSlotButton = false
  if (forMentor && paymentDetail?.feePaymentMode === 'aumhum') {
    showHoldSlotButton = true
  }
  if (forceHoldingSlot) {
    showHoldSlotButton = true
  }

  return (
    <div className="d-flex flex-column w-100">
      <Box
        sx={{
          display: 'flex',
          gap: '12px',
          flexDirection: 'column',
          width: '100%',
          '@media (min-width: 600px)': {
            flexDirection: 'row-reverse',
          },
        }}
      >
        {!hideBookButton && (
          <Button
            sx={{
              width: '100%',
              minHeight: '48px',
              fontSize: '16px',
              fontWeight: 700,
              marginBottom: '8px',
              textTransform: 'none',
              background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.95) 0%, rgba(99, 102, 241, 0.95) 100%)',
              color: '#ffffff',
              border: 'none',
              borderRadius: '10px',
              boxShadow: '0 4px 14px rgba(67, 56, 202, 0.4)',
              letterSpacing: '0.3px',
              transition: 'all 0.2s ease',
              '&:hover': {
                background: 'linear-gradient(135deg, rgba(67, 56, 202, 1) 0%, rgba(99, 102, 241, 1) 100%)',
                boxShadow: '0 6px 20px rgba(67, 56, 202, 0.5)',
                transform: 'translateY(-2px)',
              },
              '&:active': {
                transform: 'translateY(0)',
                boxShadow: '0 2px 8px rgba(67, 56, 202, 0.4)',
              },
              '&:disabled': {
                background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.4) 0%, rgba(99, 102, 241, 0.4) 100%)',
                color: 'rgba(255, 255, 255, 0.6)',
                boxShadow: 'none',
                cursor: 'not-allowed',
              },
              '@media (min-width: 600px)': {
                width: 'auto',
                minWidth: '200px',
              },
            }}
            variant="contained"
            disabled={(() => {
              if (!isEnoughTimeToBook) {
                return true
              }
              let toReturn = false
              if (askPayment) {
                if (paymentDetail?.feePaid && paymentDetail?.feePaymentMode) {
                  if (paymentDetail?.feePaymentMode === 'cash') {
                    toReturn = false
                  } else if (paymentDetail?.feePaymentMode !== 'cash') {
                    toReturn = false
                  } else {
                    toReturn = true
                  }
                } else {
                  toReturn = true
                }
              } else {
                toReturn = false
              }
              if (
                eventDataForSelectedEventType?.type === allAvailableEventTypes.consultation &&
                !forMentor
              ) {
                if (!tryBookingScreening) {
                  if (!reasonForNotDoingScreening) {
                    toReturn = true
                  }
                }
              }

              return toReturn
            })()}
            onClick={bookNowHandler}
          >
            Book {eventDataForSelectedEventType?.type}{' '}
            {eventDataForSelectedEventType?.meetingSrc === 'offline' && '(In Clinic)'}
            {eventDataForSelectedEventType?.meetingSrc === 'aumhum' && '(Online/Video)'}
          </Button>
        )}
        {forMentor &&
          paymentLinkToSendViaQRCodeFunction &&
          paymentDetail?.feePaymentMode === 'aumhum' && (
            <Button
              sx={{
                width: '100%',
                minHeight: '48px',
                fontSize: '16px',
                fontWeight: 600,
                marginBottom: '8px',
                textTransform: 'none',
                borderWidth: '1.5px',
                borderColor: 'rgba(67, 56, 202, 0.4)',
                color: 'rgba(67, 56, 202, 0.9)',
                borderRadius: '10px',
                letterSpacing: '0.3px',
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: 'rgba(67, 56, 202, 0.6)',
                  backgroundColor: 'rgba(67, 56, 202, 0.08)',
                  color: 'rgba(67, 56, 202, 1)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 2px 8px rgba(67, 56, 202, 0.15)',
                },
                '&:active': {
                  backgroundColor: 'rgba(67, 56, 202, 0.12)',
                  transform: 'translateY(0)',
                },
                '&:disabled': {
                  borderColor: 'rgba(67, 56, 202, 0.2)',
                  color: 'rgba(67, 56, 202, 0.4)',
                  backgroundColor: 'transparent',
                  cursor: 'not-allowed',
                },
                '@media (min-width: 600px)': {
                  width: 'auto',
                  minWidth: '200px',
                },
              }}
              variant="outlined"
              disabled={(() => {
                if (!isEnoughTimeToBook) {
                  return true
                }
                if (askPayment) {
                  if (paymentDetail?.feePaid && paymentDetail?.feePaymentMode) {
                    if (paymentDetail?.feePaymentMode === 'cash') {
                      return false
                    } else if (paymentDetail?.feePaymentMode !== 'cash') {
                      return false
                    } else {
                      return true
                    }
                  } else {
                    return true
                  }
                } else {
                  return false
                }
              })()}
              onClick={async () => {
                const returnedObject = await makeBookingInDayViewCalendar(
                  forMentor,
                  clinicId,
                  clinicBrandId,
                  mentorProfileData?.id,
                  askPayment,
                  clickedWantedSlotData,
                  eventDataForSelectedEventType,
                  selectedPatient,
                  updateBookingsInCalendar,
                  setNewBookingDialogOpen,
                  {
                    feePaid: paymentDetail?.feePaid,
                    feePaymentMode: paymentDetail?.feePaymentMode,
                    feePaidTxnId: paymentDetail?.feePaidTxnId,
                    currency: paymentDetail?.currency,
                    feeCollectionNote: paymentDetail?.feeCollectionNote || '',
                  },
                  setBookingLoading,
                  setSelectedPatient,
                  setIsNewPatient,
                  setNewPatientInputData,
                  chosenChamberRoomId,
                  tryBookingScreening,
                  true,
                  null,
                  null,
                  selectedRelatedConsultationForTherapy,
                  meetingBookApiSignature,
                  true,
                )
                if (paymentLinkToSendViaQRCodeFunction) {
                  paymentLinkToSendViaQRCodeFunction({
                    ...returnedObject,
                    currentPatient: selectedPatient,
                  })
                }
              }}
            >
              Hold Slot & Show Payment QR to Patient
            </Button>
          )}
        {showHoldSlotButton && (
          <HoldSlotAndSendLInkToPayButton
            forceDisable={!isEnoughTimeToBook}
            askPayment={askPayment}
            paymentDetail={paymentDetail}
            forMentor={forMentor}
            clinicId={clinicId}
            clinicBrandId={clinicBrandId}
            mentorProfileData={mentorProfileData}
            clickedWantedSlotData={clickedWantedSlotData}
            eventDataForSelectedEventType={eventDataForSelectedEventType}
            selectedPatient={selectedPatient}
            updateBookingsInCalendar={updateBookingsInCalendar}
            setNewBookingDialogOpen={setNewBookingDialogOpen}
            setBookingLoading={setBookingLoading}
            setSelectedPatient={setSelectedPatient}
            setIsNewPatient={setIsNewPatient}
            setNewPatientInputData={setNewPatientInputData}
            chosenChamberRoomId={chosenChamberRoomId}
            tryBookingScreening={tryBookingScreening}
            selectedRelatedConsultationForTherapy={selectedRelatedConsultationForTherapy}
            meetingBookApiSignature={meetingBookApiSignature}
            relativeInformation={
              selectedPatient?.primaryPatientProfile
                ? {
                    ...relatedToPatient,
                    dependentRelation: selectedPatient?.primaryPatientProfile?.dependentRelation,
                  }
                : null
            }
          />
        )}
        {forMentor && PAY_IN_FUTURE_ALLOWED_MENTOR_IDS.includes(mentorProfileData?.id) && (
          <Button
            sx={{
              width: '100%',
              minHeight: '48px',
              fontSize: '16px',
              fontWeight: 600,
              marginBottom: '8px',
              textTransform: 'none',
              borderWidth: '1.5px',
              borderColor: 'rgba(67, 56, 202, 0.4)',
              color: 'rgba(67, 56, 202, 0.9)',
              borderRadius: '10px',
              letterSpacing: '0.3px',
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: 'rgba(67, 56, 202, 0.6)',
                backgroundColor: 'rgba(67, 56, 202, 0.08)',
                color: 'rgba(67, 56, 202, 1)',
                transform: 'translateY(-1px)',
                boxShadow: '0 2px 8px rgba(67, 56, 202, 0.15)',
              },
              '&:active': {
                backgroundColor: 'rgba(67, 56, 202, 0.12)',
                transform: 'translateY(0)',
              },
              '&:disabled': {
                borderColor: 'rgba(67, 56, 202, 0.2)',
                color: 'rgba(67, 56, 202, 0.4)',
                backgroundColor: 'transparent',
                cursor: 'not-allowed',
              },
              '@media (min-width: 600px)': {
                width: 'auto',
                minWidth: '200px',
              },
            }}
            variant="outlined"
            disabled={(() => {
              if (!isEnoughTimeToBook) {
                return true
              }
              // Match the main booking button's disabled logic for consistency
              if (askPayment) {
                if (paymentDetail?.feePaid && paymentDetail?.feePaymentMode) {
                  if (paymentDetail?.feePaymentMode === 'cash') {
                    return false
                  } else if (paymentDetail?.feePaymentMode !== 'cash') {
                    return false
                  } else {
                    return true
                  }
                } else {
                  return true
                }
              } else {
                return false
              }
            })()}
            onClick={() => {
              makeBookingInDayViewCalendar(
                forMentor,
                clinicId,
                clinicBrandId,
                mentorProfileData?.id,
                askPayment,
                clickedWantedSlotData,
                eventDataForSelectedEventType,
                selectedPatient,
                updateBookingsInCalendar,
                setNewBookingDialogOpen,
                {
                  feePaid: paymentDetail?.feePaid,
                  feePaymentMode: paymentDetail?.feePaymentMode,
                  feePaidTxnId: paymentDetail?.feePaidTxnId,
                  currency: paymentDetail?.currency,
                  feeCollectionNote: paymentDetail?.feeCollectionNote || '',
                },
                setBookingLoading,
                setSelectedPatient,
                setIsNewPatient,
                setNewPatientInputData,
                chosenChamberRoomId,
                tryBookingScreening,
                false,
                null,
                'payInFuture',
                selectedRelatedConsultationForTherapy,
              )
            }}
          >
            Auto Deduct Credits in Future (Beta)
          </Button>
        )}
      </Box>
      {!isEnoughTimeToBook && (
        <div
          style={{ fontWeight: 500, textAlign: 'center', color: '#b73c30', marginBottom: '20px' }}
        >
          This session overlaps with other sessions! Please select a different event type or time to
          book.
        </div>
      )}
    </div>
  )
}
